import examples from './examples';
import gridExamples from './gridExamples.json';

export default [...examples, gridExamples];
